module.exports = __webpack_public_path__ + "media/images/landing/browser_perspective.es-original-ecd8fff823f3ebb123ae471fe8d6f158.png";